function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createSelector } from 'reselect';
import { REWORK_GOAL } from 'researcher/order-form/order/constants';
import * as c from './constants';
var initialState = {
  fileTypes: [],
  journalDetails: {
    required: false,
    requested: false
  },
  questions: [],
  questionsRequiringPreviousSelection: {},
  status: {
    loaded: false
  }
};
var getQuestions = function getQuestions(_ref) {
  var serviceDetails = _ref.serviceDetails;
  return serviceDetails.questions;
};
export var getOptionalQuestions = createSelector(getQuestions, function (_ref2) {
  var order = _ref2.order;
  return order.order.currentStep;
}, function (questions, currentStep) {
  if (currentStep === 'rework-get-started') {
    return [];
  }
  return questions.filter(function (question) {
    return !question.required;
  });
});
export var getRequiredQuestions = createSelector(getQuestions, function (_ref3) {
  var order = _ref3.order;
  return order.order.currentStep;
}, function (_ref4) {
  var _order$order;
  var order = _ref4.order;
  return order === null || order === void 0 || (_order$order = order.order) === null || _order$order === void 0 || (_order$order = _order$order.customerGoal) === null || _order$order === void 0 ? void 0 : _order$order.name;
}, function (questions, currentStep, customerGoal) {
  var requiredQuestions = questions.filter(function (question) {
    return question.required;
  });
  if (currentStep === 'details' && customerGoal === REWORK_GOAL) {
    var redundantQuestions = ['reedit-request-reason', 'rework-request-reason', 'word-count-reduction-abstract-reedit'];
    var filteredRequiredQuestions = requiredQuestions.filter(function (question) {
      return redundantQuestions.indexOf(question.label) === -1;
    });
    var displayedRequiredQuestions = filteredRequiredQuestions.filter(function (question) {
      return question.displayed;
    });
    return displayedRequiredQuestions.length > 0 ? filteredRequiredQuestions : [];
  }
  return requiredQuestions;
});
export var getJournalSelectionDisplayed = createSelector(function (_ref5) {
  var serviceDetails = _ref5.serviceDetails;
  return serviceDetails.journalDetails;
}, function (journalDetails) {
  return journalDetails.requested || journalDetails.required;
});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.SERVICE_DETAILS_CLEARED:
      return initialState;
    case c.SERVICE_DETAILS_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        fileTypes: action.fileTypes,
        journalDetails: action.journalDetails,
        questions: action.questions,
        questionsRequiringPreviousSelection: action.questionsRequiringPreviousSelection,
        status: {
          loaded: true
        }
      });
    default:
      return state;
  }
});